import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import { partnerActivityAdd, partnerActivityEdit } from '@/api/marketing/marketingManage'
import type { PartnerManage } from '@/typings/api/marketingManage'
import CustomerArea from '@/components/CustomerArea'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import { selectForNumberValidate } from '@/utils/validate'
import { cloneDeep } from 'lodash-es'

const __default__ = { name: 'partnerActivityFrom' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  view: {
    type: Boolean
  }
},
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit

const formRef = ref()
const loading = ref(false)
const visible = ref(false)
const form = ref<PartnerManage['partnerContact']>({})
const toggle = (row?: PartnerManage['partnerContact']) => {
  if (row) {
    form.value = cloneDeep(row)
  } else {
    form.value = {}
  }
  visible.value = !visible.value
}
__expose({
  toggle
})
// 新增编辑提交
const handleSubmit = () => {
  formRef.value.validate().then(async () => {
    loading.value = true
    try {
      const { partnerName, ...other } = form.value
      if (form.value.id) {
        await partnerActivityEdit(other)
        message.success('编辑成功')
        emit('success')
      } else {
        await partnerActivityAdd(other)
        message.success('新增成功')
        emit('success', 'add')
      }
      toggle()
    } catch (error) {}
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_CosInputNumber = _resolveComponent("CosInputNumber")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((visible).value = $event)),
    title: __props.view ? '查看' : form.value.id ? '编辑活动' : '新增活动',
    class: "clueMerge",
    width: "670px",
    onOk: handleSubmit,
    hideOk: __props.view,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      _createVNode(_component_CosViewContent, { view: __props.view }, {
        default: _withCtx(() => [
          (visible.value)
            ? (_openBlock(), _createBlock(_component_a_form, {
                key: 0,
                model: form.value,
                ref_key: "formRef",
                ref: formRef
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    name: "name",
                    rules: {
            required: true,
            message: '请输入'
          },
                    label: "活动名称"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.name,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
                        placeholder: "请输入",
                        disabled: __props.view,
                        view: __props.view
                      }, null, 8, ["value", "disabled", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    name: "startTime",
                    label: "活动时间"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: form.value.startTime,
                        "onUpdate:startTime": _cache[1] || (_cache[1] = ($event: any) => ((form.value.startTime) = $event)),
                        endTime: form.value.endTime,
                        "onUpdate:endTime": _cache[2] || (_cache[2] = ($event: any) => ((form.value.endTime) = $event)),
                        disabled: __props.view,
                        view: __props.view
                      }, null, 8, ["startTime", "endTime", "disabled", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    name: "cost",
                    rules: {
            required: true,
            message: '请输入'
          },
                    label: "活动费用"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: form.value.cost,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.cost) = $event)),
                        min: 0,
                        maxlength: 15,
                        placeholder: "请输入",
                        disabled: __props.view,
                        view: __props.view
                      }, null, 8, ["value", "disabled", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "是否参加",
                    name: "joinFlag",
                    rules: [{ required: true, validator: _unref(selectForNumberValidate), message: '请选择' }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        value: form.value.joinFlag,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.joinFlag) = $event)),
                        allowClear: "",
                        placeholder: "请选择",
                        options: _unref(dataConfig).joinFlag,
                        view: __props.view,
                        disabled: __props.view
                      }, null, 8, ["value", "options", "view", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_a_form_item, {
                    name: "resultEvaluate",
                    label: "活动区域"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CustomerArea), {
                        value: form.value.areaId,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.areaId) = $event)),
                        label: form.value.areaName,
                        "onUpdate:label": _cache[6] || (_cache[6] = ($event: any) => ((form.value.areaName) = $event)),
                        view: __props.view,
                        disabled: __props.view
                      }, null, 8, ["value", "label", "view", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "活动效果评估",
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosTextarea, {
                        value: form.value.resultEvaluate,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((form.value.resultEvaluate) = $event)),
                        placeholder: "请输入",
                        view: __props.view,
                        disabled: __props.view
                      }, null, 8, ["value", "view", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["view"])
    ]),
    _: 1
  }, 8, ["visible", "title", "hideOk", "confirmLoading"]))
}
}

})